let name = {
  mask: {
    mask: "####################",
    tokens: { "#": { pattern: /[A-zÀ-ú-.' ]/ } }
  },

  validator: value => value && String(value).trim().length
}

let plate = {
  mask: {
    mask: "#########",
    tokens: {
      "#": {
        pattern: /[A-z0-9]/,
        transform: v => v.toLocaleUpperCase()
      }
    }
  },

  transform: value => {
    value = value.replace(/\s/g, "")
    let groups = value.match(/\d+|\D+/gi) || []
    return groups.length ? groups.join(" ") : value
  },

  validator: value => /^([A-Z]{2} [0-9]{3} [A-Z]{2})$/.test(value) || /^([0-9]{1,4} [A-Z]{1,3} [0-9]{2})$/.test(value),
}

let email = {
  mask: {
    mask: "################################################################",
    tokens: { "#": { pattern: /[A-z0-9.\-_@]/ } }
  },

  // eslint-disable-next-line
  validator: value => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value),
}

let phoneNumber = {
  mask: "## ## ## ## ##",

  validator: value => /^[0-9]{10}$/.test((value || "").replace(/\s/g, ""))
}

export default {
  name,
  plate,
  email,
  phoneNumber
}
